import { AdjustAPI } from "./adjust";
import { AdvertisementAPI } from "./advertisement";
import { AffiliateAPI } from "./affiliate";
import { AppUpdateAPI } from "./appUpdate";
import { AdminBoardAPI } from "./article";
import { AdminAttendanceAPI } from "./attendance";
import { BrandCompetitionAPI } from "./brandCompetition";
import { CafeAPI } from "./cafe";
import { CommentAPI } from "./comment";
import { CompetitionAPI } from "./competition";
import { CouponAPI } from "./coupon";
import { EventAPI } from "./event";
import { FaqAPI } from "./faq";
import { UserJobOpeningAPI } from "./jobOpening";
import { GameInspectionScheduleAPI } from "./gameInspectionSchedule";
import { NewsAPI } from "./news";
import { NoticeAPI } from "./notice";
import { OpenChatAPI } from "./openChat";
import { PopupNoticeAPI } from "./popUpNotice";
import { PubGradeApi } from "./pub-grade";
import { PubMessageAPI } from "./pubMessage";
import { ReviewAPI } from "./review";
import { RouletteAPI } from "./roulette";
import { SearchAPI } from "./search";
import { SecondHandMarketAPI } from "./secondHandMarket";
import { TournamentAPI } from "./tournament";
import { UserAPI } from "./user";
import { UserMessageAPI } from "./userMessage";
import { YoutubeAPI } from "./youtube";
import { InterviewAPI } from "./interview";
import { SearchBannerAPI } from "./search-banner";
import { ClubRewardAPI } from "./club-reward";
import { TournamentAdVideoAPI } from "./tournament-ad-video";
import { EventScheduleAPI } from "./event-schedule";
import { RunnerCompetitionAPI } from "./runner-competition";
import { ImagePopupAPI } from "./image-popup";

const AdminAPI = {
  ...CompetitionAPI,
  ...RouletteAPI,
  ...BrandCompetitionAPI,
  ...CafeAPI,
  ...FaqAPI,
  ...UserJobOpeningAPI,
  ...PopupNoticeAPI,
  ...TournamentAPI,
  ...UserAPI,
  ...SecondHandMarketAPI,
  ...EventAPI,
  ...AffiliateAPI,
  ...AdvertisementAPI,
  ...YoutubeAPI,
  ...OpenChatAPI,
  ...NoticeAPI,
  ...NewsAPI,
  ...CommentAPI,
  ...AdjustAPI,
  ...AppUpdateAPI,
  ...SearchAPI,
  ...ReviewAPI,
  ...UserMessageAPI,
  ...PubMessageAPI,
  ...AdminBoardAPI,
  ...CouponAPI,
  ...AdminAttendanceAPI,
  ...PubGradeApi,
  ...GameInspectionScheduleAPI,
  ...InterviewAPI,
  ...SearchBannerAPI,
  ...ClubRewardAPI,
  ...TournamentAdVideoAPI,
  ...EventScheduleAPI,
  ...RunnerCompetitionAPI,
  ...ImagePopupAPI,
};
export default AdminAPI;
